<footer #footer class="bg-[#082028] text-white font-lato">
    <div class="max-width-container">
        <div class="main-container side-padding flex lg:flex-row flex-col justify-between pb-5 pt-8">
            <div class="left-container">
                <div class="brand-logo bg-yyc-brand-logo-white-text h-8 bg-no-repeat bg-contain"></div>
                <div class="contact-us-info mt-6 mb-8">
                    <h2 class="font-medium">{{ 'text.contactUs' | translate }}</h2>
                    <div class="contact-us-description mt-2 w-[75%]">
                        {{ 'footer.contactUsDescription' | translate: { application_name: APPLICATION_NAME } }}
                    </div>
                </div>
                <div class="mb-3">
                    <a class="flex items-center w-fit" [href]="'mailto:' + CUSTOMER_SUPPORT_EMAIL">
                        <img class="inline-block w-6 mr-2" src="./assets/images/support_email_icon.png" alt="email" />
                        <span>{{ CUSTOMER_SUPPORT_EMAIL }}</span>
                    </a>
                </div>
                <div class="whats-app-info xl:flex lg:content-center">
                    <div *ngFor="let item of whatsAppLinAPILinks"
                        class="relative mb-2 xl:px-3.5 xl:first:pl-0 xl:last:pr-0 xl:first:before:hidden xl:before:border-l xl:before:border-l-[#1D3D3E] xl:before:content-[''] xl:before:h-4 xl:before:absolute xl:before:top-[0.28125rem] xl:before:left-0">
                        <a class="flex items-center" target="_blank" rel="noopener" [href]="item.link">
                            <img class="inline-block h-6 mr-2" src="./assets/images/whatsapp_icon.png" alt="whatsapp" />
                            <span>{{ item.phoneNo }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="right-container md:mt-0 mt-6">
                <h2 class="font-medium mb-4">{{ 'footer.downloadOurApp' | translate }}</h2>
                <div class="download-link-container flex lg:flex-row flex-col lg:gap-1 lg:ml-0 justify-end">
                    <a class="block mb-2" href="https://apps.apple.com/us/app/yyc-taxpod-2-0/id6743611689"
                        appAddTargetBlankNoOpener>
                        <div class="bg-apple-store-download bg-contain bg-no-repeat h-[58px] w-[178px]"></div>
                    </a>
                    <a class="block mb-2" href="https://play.google.com/store/apps/details?id=my.taxpod.learn.v2"
                        appAddTargetBlankNoOpener>
                        <div class="bg-google-store-download bg-contain bg-no-repeat lg:h-[58px] h-[52px] lg:w-[200px]">
                        </div>
                    </a>
                    <a class="block mb-2" href="https://appgallery.huawei.com/app/C113845937" appAddTargetBlankNoOpener>
                        <div class="bg-huawei-gallery-download bg-contain bg-no-repeat lg:h-[58px] h-[52px] w-[200px]">
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <hr class="border-t-[#113C4B] border-t-[1px]" />
    <div class="max-width-container side-padding">
        <div class="md:grid md:grid-cols-5 text-sm text-[#AFB9BC] relative bottom-footer-padding">
            <div class="copyright text-left md:col-span-5">
                <a routerLink="/release-notes" [innerHTML]="
                        'footer.copyrightInfo'
                            | translate
                                : {
                                      year: currentYear,
                                      application_name: BRAND,
                                      version: APP_VERSION,
                                  }
                    ">
                </a>
            </div>

            <div class="terms-and-privacy-styling">
                <a appAddTargetBlankNoOpener class="inline-block"
                    [href]="['/document/terms-and-conditions']">
                    {{ 'text.termsAndConditions' | translate }}
                </a>
                <a appAddTargetBlankNoOpener class="inline-block"
                    [href]="['/document/privacy-policy']">
                    {{ 'text.privacyPolicy' | translate }}
                </a>
                 <a appAddTargetBlankNoOpener class="inline-block"
                    [href]="['/document/refund-policy']">
                    {{ 'text.refundPolicy' | translate }}
                </a>
            </div>
        </div>
    </div>
</footer>